"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeTypeInconsistentRule = void 0;
exports.getInconsistentAttributeTypes = getInconsistentAttributeTypes;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * There is nothing wrong with inconsistent types on columns with identical name.
 * But sometimes, it's a hint of a same value or concept stored with a different format and may cause issues or misunderstandings.
 * Of course, not every column with the same name stores the exact same thing, and it may be totally fine.
 * Just have a look to be aware, and fix what need to be fixed.
 */
const ruleId = 'attribute-type-inconsistent';
const ruleName = 'inconsistent attribute type';
const ruleDescription = 'attribute names which have different types in other entities (help for consistency)';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributeName.array().optional()
}).strict().describe('AttributeTypeInconsistentConf');
exports.attributeTypeInconsistentRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.hint },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.attribute?.[0]).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores || []);
        return Object.entries(getInconsistentAttributeTypes(db.entities || []))
            .filter(([name,]) => !ignores.some(i => i === name))
            .map(([name, refs]) => {
            const refsByType = Object.entries((0, utils_1.groupBy)(refs, r => r.value.type)).sort(([, a], [, b]) => a.length - b.length);
            const message = `Attribute ${name} has several types: ${refsByType.map(([t, [r, ...others]]) => `${t} in ${(0, databaseUtils_1.attributeRefToId)(r.ref)}${others.length > 0 ? ` and ${(0, utils_1.pluralize)(others.length, 'other')}` : ''}`).join(', ')}.`;
            const { attribute, ...entity } = refsByType[0][1][0].ref;
            const attributes = refs.map(r => ({ ...r.ref, type: r.value.type }));
            return { ruleId, ruleName, ruleLevel: conf.level, message, entity, attribute: [name], extra: { attributes } };
        });
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/InconsistentTypeOnColumns.elm
function getInconsistentAttributeTypes(entities) {
    const attributes = entities.flatMap(e => (0, databaseUtils_1.flattenAttributes)(e.attrs).map(({ path, ...a }) => ({
        ref: { ...(0, databaseUtils_1.entityToRef)(e), attribute: path },
        value: a
    })));
    const attributesByName = (0, utils_1.groupBy)(attributes, a => a.value.name);
    return (0, utils_1.filterValues)(attributesByName, (attrs) => !attrs.every(a => a.value.type === attrs[0].value.type));
}
//# sourceMappingURL=attributeTypeInconsistent.js.map